import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow } from "vue"

const _hoisted_1 = ["data-cameraId"]
const _hoisted_2 = {
  key: 0,
  class: "player-container"
}
const _hoisted_3 = {
  ref: "player",
  autoplay: "",
  muted: ""
}
const _hoisted_4 = {
  ref: "stallingLabel",
  class: "stallingLabel"
}
const _hoisted_5 = {
  ref: "playButton",
  class: "playButton"
}
const _hoisted_6 = {
  ref: "pauseButton",
  class: "pauseButton"
}
const _hoisted_7 = {
  ref: "loading",
  class: "loading rotating"
}
const _hoisted_8 = {
  key: 1,
  class: "controls-panel"
}
const _hoisted_9 = {
  class: "mbr-controls",
  ref: "mbr-controls"
}
const _hoisted_10 = {
  name: "videoTracks",
  id: "videoTracks",
  ref: "videoTracks"
}
const _hoisted_11 = {
  name: "audioTracks",
  id: "audioTracks",
  ref: "audioTracks"
}
const _hoisted_12 = { style: {"float":"right"} }
const _hoisted_13 = ["src"]
const _hoisted_14 = ["muted", "controls"]
const _hoisted_15 = {
  key: 4,
  class: "spinner-overlay"
}
const _hoisted_16 = {
  id: "message",
  ref: "message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IonIcon = _resolveComponent("IonIcon")!
  const _directive_observe_visibility = _resolveDirective("observe-visibility")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "video",
    class: "camera_live",
    "data-cameraId": _ctx.cameraId,
    draggable: true,
    onDragover: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["prevent"])),
    onDragstart: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.handleDragStart && _ctx.handleDragStart(...args))),
    onDragend: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.handleDragEnd && _ctx.handleDragEnd(...args)))
  }, [
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("video", _hoisted_3, null, 512),
          _createElementVNode("div", _hoisted_4, " [callbacks] ", 512),
          _createElementVNode("div", _hoisted_5, "▶", 512),
          _createElementVNode("div", _hoisted_6, "▌▌", 512),
          _createElementVNode("div", _hoisted_7, "◌", 512)
        ]))
      : _createCommentVNode("", true),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", null, [
              _cache[17] || (_cache[17] = _createElementVNode("label", { for: "videoTracks" }, "video tracks", -1)),
              _createElementVNode("select", _hoisted_10, null, 512)
            ]),
            _createElementVNode("div", null, [
              _cache[18] || (_cache[18] = _createElementVNode("label", { for: "audioTracks" }, "audio tracks", -1)),
              _createElementVNode("select", _hoisted_11, null, 512)
            ]),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setTracks()))
            }, "set tracks")
          ], 512),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.player.play()))
            }, "Play"),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.player.stop()))
            }, "Stop"),
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.player.pause()))
            }, "Pause"),
            _createElementVNode("button", {
              ref: "muted",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.unmute()))
            }, "Unmute", 512)
          ])
        ]))
      : _createCommentVNode("", true),
    true
      ? (_openBlock(), _createElementBlock("iframe", {
          key: 2,
          onDragover: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
          src: _ctx.url,
          allowfullscreen: "",
          style: `width: 100% !important; height: 100% !important; background-color: black;`
        }, null, 40, _hoisted_13))
      : _createCommentVNode("", true),
    false
      ? _withDirectives((_openBlock(), _createElementBlock("video", {
          key: 3,
          style: _normalizeStyle(`pointer-events: ${!_ctx.isMobile() ? 'none': 'initial'} !important; width: 100% !important; height: 100% !important; background-color: black;`),
          ref: "videortc",
          preload: "auto",
          muted: _ctx.muted,
          controls: _ctx.controls || _ctx.iOSCompatControls,
          onDragover: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"])),
          onLoadeddata: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleLoadedData && _ctx.handleLoadedData(...args))),
          onProgress: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleProgress && _ctx.handleProgress(...args))),
          onPlaying: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handlePlaying && _ctx.handlePlaying(...args))),
          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args))),
          onError: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleError && _ctx.handleError(...args)))
        }, null, 44, _hoisted_14)), [
          [_directive_observe_visibility, _ctx.visibilityChanged]
        ])
      : _createCommentVNode("", true),
    (false && !_ctx.isVideoPlaying)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "spinner" }, [
            _createElementVNode("div"),
            _createElementVNode("div"),
            _createElementVNode("div"),
            _createElementVNode("div")
          ], -1)),
          _createElementVNode("p", null, _toDisplayString(_ctx.t('Loading')) + "...", 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_16, null, 512),
    _withDirectives(_createElementVNode("button", {
      onDragover: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["prevent"])),
      onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.fullscreen && _ctx.fullscreen(...args))),
      class: "btn_fullscreen"
    }, [
      _createVNode(_component_IonIcon, { icon: _ctx.scanOutline }, null, 8, ["icon"])
    ], 544), [
      [_vShow, !_ctx.isMobile()]
    ])
  ], 40, _hoisted_1))
}